import { RouteConfig } from 'vue-router/types/router';
import MswManageCases from './msw-manage-case.vue';
import MswSupportCases from './msw-support-cases.vue';

export const managecases: RouteConfig = {
  path: 'managecases',
  component: MswManageCases,
};

export const supportcases: RouteConfig = {
  path: 'supportcases',
  component: MswSupportCases,
};
